export default {
  api: 'https://api-lookup.curvolabs.com/graphql',
  cognitoPoolId: 'us-east-1_LfkoUV1Fr',
  cognitoClientId: '167vb116s1dcnqak27g34d3krc',
  useMixpanel: '5297524681ccc486267fb10c2c30981c',
  launchDarklyClientId: '5dad84acf02fbd081685de49',
  useHubspot: true,
  useHeap: true,
}